import request from '@/utils/request.js'

// 获取监控屏幕信息
export const getScreenInfo = (id) => {
  return request({
    url: '/monitor/screen/info?id=' + id,
    method: 'get'
  })
}

// 获取监控屏幕列表
export const getScreenPageList = (data) => {
  return request({
    url: '/monitor/screen/page',
    method: 'post',
    data: data
  })
}

// 创建屏幕
export const createScreen = (data) => {
  return request({
    url: '/monitor/screen/create',
    method: 'post',
    data: data
  })
}

// 修改屏幕
export const updateScreen = (data) => {
  return request({
    url: '/monitor/screen/update',
    method: 'post',
    data: data
  })
}

// 删除屏幕
export const deleteScreen = (id) => {
  return request({
    url: '/monitor/screen/delete?id=' + id,
    method: 'post'
  })
}